import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/admin/react-native-list-demo",
      },
      queries: [],
    }),
    [],
  );
}

export const useReactNativeListDemoSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
